import {
    debug
} from '@kkmh/utils'
window.pagepv_is_passed_by_here = false;
/*
* @param : 
* heladikedata 赫拉迪克接口数据
* topicdata 专题信息数据
* 
*/
export const doTrackPvYingxiao = (opt={}, display_info={}) => {
    if(window.pagepv_is_passed_by_here) {
        doTrackPv(opt, display_info);
    }
}
export const doTrackPv = (opt={}, display_info={}) => {
    window.pagepv_is_passed_by_here = true;
    let activity_name = 'VisitMembershipCenter';
    let {vip_common={}} = window.heladikedata || {};
    let {comic={}, topic={}} = window.topicdata || {};
    
    let ItemName = display_info.type == 1 ? '营销区域(图标)' : display_info.type == 2 ? '营销区域(文本)' : '';
    let ActivityName = display_info.activity_name || '';

    let param = {
        CurPage             : opt.trigger_page,
        TriggerPage         : opt.origin,
        NoticeType          : opt.notice_type,
        TopicName           : topic.title || '',
        ComicName           : comic.title || '',
        MembershipClassify  : vip_common.vip_classify || '',
        MembershipDayleft   : vip_common.vip_day_left || 0,
        IsFirstOpen         : vip_common.first_open || false,
        IsVipAutoPay        : vip_common.is_auto_keep || false,
        VipFateSumAmount    : vip_common.total_vip_days || 0,
        VipPaymentSumAmount : vip_common.vip_charge_cnt || 0,
        VipBalanceSumAmount : vip_common.total_vip_fees || 0,
        VIPRight            : vip_common.vip_identity || '',

        ItemName            : ItemName,
        ActivityName        : ActivityName,
    };
    debug(activity_name, param);
    kksa.track(activity_name, param);
}

/*
* @param : 
* btnname 按钮名称
* heladikedata 赫拉迪克接口数据
* topicdata 专题信息数据
*/
export const doTrackClick = (btnname, opt={}, display_info={}) => {
    let activity_name = 'MembershipCenterBtnClk';
    let {vip_common={}} = window.heladikedata || {};
    let {comic={}, topic={}} = window.topicdata || {};
    
    let ItemName = display_info.type == 1 ? '营销区域(图标)' : display_info.type == 2 ? '营销区域(文本)' : '';
    if (ItemName) {
        btnname = ItemName + '_' + display_info.button_text;
    }
    let ActivityName = display_info.activity_name || '';

    let param = {
        CurPage             : opt.trigger_page,
        TriggerPage         : opt.origin,
        NoticeType          : opt.notice_type,
        ButtonName          : btnname || '',
        TopicName           : topic.title || '',
        ComicName           : comic.title || '',
        IsTakeSuccess       : -1,//是否领取成功1 成功 0 失败-1 其他
        MembershipClassify  : vip_common.vip_classify || '',
        MembershipDayleft   : vip_common.vip_day_left || 0,
        IsFirstOpen         : vip_common.first_open || false,
        IsVipAutoPay        : vip_common.is_auto_keep || false,
        VipFateSumAmount    : vip_common.total_vip_days || 0,
        VipPaymentSumAmount : vip_common.vip_charge_cnt || 0,
        VipBalanceSumAmount : vip_common.total_vip_fees || 0,
        VIPRight            : vip_common.vip_identity || '',

        ItemName            : ItemName,
        ActivityName        : ActivityName,
    };
    debug(activity_name, param);
    kksa.track(activity_name, param);
}



// WEBPACK FOOTER //
// ./node_modules/@kkmh/pays/src/components/viphalfscreen/js/track.js